// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"574a8d90","204":"bcb4934d","453":"0aa33c7e","780":"55f784fb","958":"998c83f2"}[chunkId] + ".chunk.js";
};